
@if (detail(); as item) {
  <div class="page-header">
    <div>
      <h1>{{ item.company.name }}</h1>
      <p>{{ item.company.organizationName }} · Unternehmerdetail und Fahrerübersicht</p>
    </div>
  </div>

  <section class="panel section-stack company-detail-access">
    <div>
      <h2>Zugangsdaten</h2>
      <div class="data-grid compact">
        <span>Login-User:</span>
        <strong>{{ valueOrDash(item.adminLoginEmail) }}</strong>
        <span>Status:</span>
        <strong>{{ item.adminActive ? 'Aktiv' : 'Inaktiv' }}</strong>
        <span>2FA:</span>
        <strong>Inaktiv</strong>
      </div>
    </div>
  </section>

  <div class="action-row company-detail-actions">
    <a class="ghost-button as-link" routerLink="/companies">Zurück zur Unternehmerübersicht</a>
    @if (canEdit()) {
      <button type="button" class="primary-button" (click)="openEditDialog(item.company)">Unternehmer bearbeiten</button>
    }
    @if (canCreateDriver()) {
      <button type="button" class="primary-button" (click)="openCreateDriverDialog()">Fahrer anlegen</button>
    }
    @if (canDelete()) {
      <button type="button" class="ghost-button danger-button" (click)="deleteCompany(item.company)">Unternehmer löschen</button>
    }
  </div>

  <section class="kpi-grid">
    <article class="panel">
      <span>Fahrer gesamt</span>
      <strong class="kpi-value">{{ item.company.driverCount }}</strong>
    </article>
    <article class="panel">
      <span>Fahrzeuge</span>
      <strong class="kpi-value">{{ item.company.vehicleCount ?? '-' }}</strong>
    </article>
    <article class="panel">
      <span>Nachschulung</span>
      <strong class="kpi-value">{{ item.company.criticalDrivers }}</strong>
    </article>
    <article class="panel">
      <span>Ø Fortschritt</span>
      <strong class="kpi-value">{{ item.company.averageProgressPercent }} %</strong>
    </article>
  </section>

  <section class="panel two-column-panel company-detail-master">
    <div>
      <h2>Stammdaten</h2>
      <div class="data-grid">
        <span>Email-Ansprechpartner:</span>
        <strong>{{ valueOrDash(item.company.contactName) }}</strong>
        <span>Telefon:</span>
        <strong>{{ valueOrDash(item.company.contactPhone) }}</strong>
        <span>Status:</span>
        <strong>{{ item.company.status }}</strong>
        <span>Adresse:</span>
        <strong>{{ address(item.company) }}</strong>
      </div>
    </div>

    <div>
      <h2>Kontakt &amp; Betrieb</h2>
      <div class="data-grid">
        <span>Kürzel:</span>
        <strong>{{ valueOrDash(item.company.shortCode) }}</strong>
        <span>E-Mail:</span>
        <strong>{{ valueOrDash(item.company.contactEmail) }}</strong>
        <span>Anzahl Fahrzeuge:</span>
        <strong>{{ item.company.vehicleCount ?? '-' }}</strong>
      </div>
    </div>
  </section>

  <section class="panel section-stack company-detail-drivers">
    <div class="panel-heading">
      <div>
        <h2>Fahrer dieses Unternehmers</h2>
      </div>
    </div>

    <table class="table">
      <thead>
        <tr>
          <th>Fahrer-ID</th>
          <th>Fahrer</th>
          <th>Fortschritt</th>
          <th>Scoring</th>
          <th>Status</th>
          <th>Offen</th>
        </tr>
      </thead>
      <tbody>
        @for (driver of item.drivers; track driver.id) {
          <tr>
            <td>{{ valueOrDash(driver.personnelNumber) }}</td>
            <td>
              <a class="table-link" [routerLink]="['/drivers', driver.id]">{{ driver.displayName }}</a><br>
              <span>{{ driver.email }}</span>
            </td>
            <td>{{ driver.progressPercent }} %</td>
            <td>{{ driver.scorePercent === null ? '-' : driver.scorePercent + ' %' }}</td>
            <td>{{ driver.status }}</td>
            <td>{{ driver.openEnrollments }}</td>
          </tr>
        } @empty {
          <tr>
            <td colspan="6">Noch keine Fahrer hinterlegt.</td>
          </tr>
        }
      </tbody>
    </table>
  </section>

  @if (editDialogOpen()) {
    <div class="modal-backdrop" role="presentation" (click)="closeEditDialog()">
      <section class="modal-panel" role="dialog" aria-modal="true" aria-labelledby="edit-company-title" (click)="$event.stopPropagation()">
        <div class="panel-heading">
          <div>
            <h2 id="edit-company-title">Unternehmer bearbeiten</h2>
            <p>Stammdaten aktualisieren.</p>
          </div>
          <button type="button" class="ghost-button" (click)="closeEditDialog()">Schließen</button>
        </div>

        <form class="dialog-form" (submit)="saveCompany($event)">
          <label class="full-width">
            <span>Unternehmer / Firmenname</span>
            <input type="text" required [value]="form().name" (input)="updateForm('name', $event)">
          </label>

          <label>
            <span>Kürzel</span>
            <input type="text" [value]="form().shortCode" (input)="updateForm('shortCode', $event)">
          </label>

          <label>
            <span>Anzahl Fahrzeuge</span>
            <input type="number" min="0" [value]="form().vehicleCount ?? ''" (input)="updateNumberForm('vehicleCount', $event)">
          </label>

          <label>
            <span>Status</span>
            <select [value]="form().status" (change)="updateForm('status', $event)">
              <option value="ACTIVE">Aktiv</option>
              <option value="TEST">Test</option>
              <option value="INACTIVE">Inaktiv</option>
            </select>
          </label>

          <label>
            <span>Email-Ansprechpartner</span>
            <input type="text" [value]="form().contactName" (input)="updateForm('contactName', $event)">
          </label>

          <label>
            <span>E-Mail</span>
            <input type="email" [value]="form().contactEmail" (input)="updateForm('contactEmail', $event)">
          </label>

          <label>
            <span>Telefon</span>
            <input type="tel" [value]="form().contactPhone" (input)="updateForm('contactPhone', $event)">
          </label>

          <label>
            <span>Straße</span>
            <input type="text" [value]="form().street" (input)="updateForm('street', $event)">
          </label>

          <label>
            <span>PLZ</span>
            <input type="text" [value]="form().postalCode" (input)="updateForm('postalCode', $event)">
          </label>

          <label>
            <span>Ort</span>
            <input type="text" [value]="form().city" (input)="updateForm('city', $event)">
          </label>

          <label>
            <span>Land</span>
            <input type="text" [value]="form().country" (input)="updateForm('country', $event)">
          </label>

          @if (saveError()) {
            <p class="field-error full-width">{{ saveError() }}</p>
          }

          <div class="dialog-actions full-width">
            <button type="button" class="ghost-button" (click)="closeEditDialog()">Abbrechen</button>
            <button type="submit" class="primary-button" [disabled]="saving()">
              {{ saving() ? 'Wird gespeichert...' : 'Speichern' }}
            </button>
          </div>
        </form>
      </section>
    </div>
  }

  @if (createDriverDialogOpen()) {
    <div class="modal-backdrop" role="presentation" (click)="closeCreateDriverDialog()">
      <section class="modal-panel wide-modal" role="dialog" aria-modal="true" aria-labelledby="create-driver-title" (click)="$event.stopPropagation()">
        <div class="panel-heading">
          <div>
            <h2 id="create-driver-title">Neuen Fahrer anlegen</h2>
            <p>Stammdaten, Betrieb und Fahrerstatus erfassen.</p>
          </div>
          <button type="button" class="ghost-button" (click)="closeCreateDriverDialog()">Schließen</button>
        </div>

        <div class="form-with-hint">
          <form class="dialog-form" (submit)="createDriver($event)">
            <label>
              <span>Vorname</span>
              <input type="text" required [value]="driverForm().firstName" (input)="updateDriverForm('firstName', $event)">
            </label>

            <label>
              <span>Nachname</span>
              <input type="text" required [value]="driverForm().lastName" (input)="updateDriverForm('lastName', $event)">
            </label>

            <label>
              <span>E-Mail</span>
              <input type="email" required [value]="driverForm().email" (input)="updateDriverForm('email', $event)">
            </label>

            <label>
              <span>Telefon</span>
              <input type="tel" [value]="driverForm().phone" (input)="updateDriverForm('phone', $event)">
            </label>

            <label>
              <span>Fahrernummer</span>
              <input type="text" [value]="driverForm().personnelNumber" (input)="updateDriverForm('personnelNumber', $event)">
            </label>

            <label>
              <span>Betrieb</span>
              <input type="text" [value]="item.company.name" disabled>
            </label>

            <label class="full-width">
              <span>Fahrergruppe</span>
              <select multiple size="2" (change)="updateDriverGroups($event)">
                @for (group of driverGroupOptions(); track group.id) {
                  <option [value]="group.id" [selected]="driverForm().groupIds.includes(group.id)">{{ group.name }}</option>
                }
              </select>
              <small>Wähle eine oder mehrere Fahrergruppen aus, zum Beispiel Neue Fahrer, Nachschulung oder Krankenfahrt.</small>
            </label>

            <label>
              <span>Bevorzugte Sprache</span>
              <select [value]="driverForm().preferredLanguage" (change)="updateDriverForm('preferredLanguage', $event)">
                <option value="de">Deutsch</option>
                <option value="en">Englisch</option>
                <option value="tr">Türkisch</option>
                <option value="ar">Arabisch</option>
                <option value="uk">Ukrainisch</option>
                <option value="ru">Russisch</option>
              </select>
            </label>

            <label>
              <span>Fahrerstatus</span>
              <select [value]="driverForm().status" (change)="updateDriverForm('status', $event)">
                <option value="ACTIVE">Aktiv</option>
                <option value="TRAINING_IN_PROGRESS">In Schulung</option>
                <option value="READY">Einsatzbereit</option>
                <option value="RETRAINING_REQUIRED">Nachschulung erforderlich</option>
                <option value="OVERDUE">Überfällig</option>
                <option value="BLOCKED">Gesperrt</option>
                <option value="INACTIVE">Inaktiv</option>
              </select>
            </label>

            <label>
              <span>P-Schein gültig bis</span>
              <input type="date" [value]="driverForm().pScheinValidUntil" (input)="updateDriverForm('pScheinValidUntil', $event)">
            </label>

            <label>
              <span>Fahrerstatus aktiv bis</span>
              <input type="date" [value]="driverForm().statusValidUntil" (input)="updateDriverForm('statusValidUntil', $event)">
            </label>

            @if (driverCreateError()) {
              <p class="field-error full-width">{{ driverCreateError() }}</p>
            }

            <div class="dialog-actions full-width">
              <button type="submit" class="primary-button" [disabled]="driverSaving()">
                {{ driverSaving() ? 'Wird angelegt...' : 'Fahrer anlegen' }}
              </button>
              <button type="button" class="ghost-button" (click)="closeCreateDriverDialog()">Abbrechen</button>
            </div>
          </form>

          <aside class="hint-panel">
            <h3>Hinweis</h3>
            <p>Beim Anlegen wird noch kein Passwort vergeben. Sende danach in der Fahrerakte den Passwort-Link an den Fahrer.</p>
          </aside>
        </div>
      </section>
    </div>
  }
} @else {
  <div class="empty">Unternehmer wird geladen.</div>
}
  
